export const base_filter = [{ key: "search", label: "Buscar", type: "text", value: "", visible: true, placeholder: "Nombre" }];

export const base_table = { page: 1, per_page: 10, order_by: "name", order_dir: "asc" };

export const base_object = { id: "", name: "", estate_parent_id: "", estate_id: "", machinery_type_id: "" };
